import * as Sentry from '@sentry/vue';

if (!process.env.DEBUG_LOGGING) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    //* Session replay sample rates
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [// https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/40
    // https://stackoverflow.com/questions/75536442/troubleshooting-non-error-promise-rejection-captured-with-value-object-not-fou
    'Non-Error promise rejection captured with value: Object Not Found Matching Id', 'Non-Error exception captured with keys: message, previous, status, type'],
    environment: process.env.SENTRY_ENV,
    integrations: [Sentry.browserTracingIntegration(), // In later versions of sentry - this integration is enabled by default. It is recommended to
    // enable this to aid in issues such as FIB-8269.
    Sentry.dedupeIntegration(), // implement the replay integration
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true
    })]
  });
}

export function throwErrors(error) {
  Logger.error('Error Response: ', error);

  if (!process.env.DEBUG_LOGGING) {
    Sentry.captureException(error, function (sendErr) {
      // This callback fires once the report has been sent to Sentry
      if (sendErr) {
        Logger.error('Failed to send captured exception to Sentry', error);
      }
    });
  }
}